import type currency from 'currency.js';
import * as React from 'react';
import currencyFormat from 'ui/utils/currencyFormat';

const Currency: React.FC<{ value: currency }> = ({ value }) => (
  <span className="currency">{value.format(currencyFormat)}</span>
);

export default Currency;
